import React from 'react';

import { GalleryBlockContent } from '../../../../../../components/shared/LandingPage/blocks/Gallery';
import { useGallery } from './functions';
import { IGalleryBlockProps } from './types';

function GalleryBlock(props: IGalleryBlockProps) {
  const { data: blockData } = props;
  const contentProps = useGallery(props);

  return <GalleryBlockContent {...contentProps} blockData={blockData} />;
}

export default GalleryBlock;
